<template>
    <div>
        <b-button @click="downloadPdf" size="xl" variant="primary">
            Download en print PDF
        </b-button>
    </div>
</template>

<script>
export default {
    name: "TestPdfDownload",

    methods: {
        downloadPdf() {
            this.printPdf('/test.pdf')
        },
        printPdf(url) {
            let iframe = document.createElement('iframe');
            document.body.appendChild(iframe);

            iframe.onload = function() {
                setTimeout(function() {
                    iframe.focus();
                    iframe.contentWindow.print();
                }, 1);
            };

            iframe.src = url;
        },
    },
}
</script>
